export default __webpack_public_path__ + "static/media/menu34.76d4180c.svg";